import React from 'react'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import { Modal } from 'antd'
import { Row } from 'antd'
import PaymentTermsForm from '../../../../components/Purchasing/VendorQuotes/PaymentsTerms/PaymentTermsForm'

PaymentTermsModal.propTypes = {}

function PaymentTermsModal(props) {
  const {
    visible,
    onCancel,
    remove,
    removing,
    submit,
    update,
    submitting,
    isNew,
    isUpdatable,
    formRef,
  } = props
  return (
    <Modal
      visible={visible}
      title={'Payment Term'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={!!isUpdatable}
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Payment Term'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Row>
        <PaymentTermsForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

export default PaymentTermsModal
